import React from 'react';
import BrandLogo from './BrandLogo';

const brandSlugs = [
  'amazon', 'flipkart', 'meesho', 'myntra', 'ebay', 'etsy', 'jiomart', 'shopclues', 'instagram', 'facebook',
];

export default function BrandsMarquee() {
  const doubled = [...brandSlugs, ...brandSlugs];
  return (
    <section className="py-14 bg-white border-y border-neutral-100 overflow-hidden">
      <div className="container-x mb-8 text-center">
        <div className="eyebrow">Platforms we work with</div>
        <p className="text-sm text-[color:var(--ink-soft)] mt-2">
          Trusted partner across the top Indian &amp; global marketplaces and social platforms
        </p>
      </div>
      <div className="relative no-scrollbar">
        <div className="flex gap-6 items-center marquee-track w-max">
          {doubled.map((slug, i) => (
            <div
              key={i}
              className="h-24 w-48 shrink-0 bg-white rounded-2xl border border-neutral-200 shadow-sm flex items-center justify-center px-5 hover:shadow-lg hover:-translate-y-1 hover:border-[color:var(--brand-green)]/50 transition-all"
            >
              <BrandLogo slug={slug} className="h-12 w-auto" />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
